import { useMemo } from 'react'

import { InvoiceStatus } from '@features/invoices/enums/invoiceStatus'

import { SalesOverviewReportTableAccessor } from '../../enums/salesOverviewReportTableAccessor'
import { SalesReportDateSelection } from '../../enums/salesReportDateSelection'
import { SalesOverviewReportTableRow } from '../../types/salesOverviewReportTableRow'
import { useSalesOverviewReport } from './useSalesOverviewReport'

export const useSalesOverviewReportTableData = (): SalesOverviewReportTableRow[] => {
  const { dateSelection, salesOverviewReport } = useSalesOverviewReport()

  return useMemo(
    () =>
      salesOverviewReport.map(
        ({ customerName, grossTotal, id, invoiceNumber, issueDate, netTotal, paidDate, status, taxTotal }) => {
          const isPaidInvoice = dateSelection === SalesReportDateSelection.Payment || status === InvoiceStatus.Paid

          return {
            [SalesOverviewReportTableAccessor.CustomerName]: customerName,
            [SalesOverviewReportTableAccessor.GrossTotal]: grossTotal,
            [SalesOverviewReportTableAccessor.InvoiceNumber]: invoiceNumber,
            [SalesOverviewReportTableAccessor.IssueDate]: issueDate,
            [SalesOverviewReportTableAccessor.NetTotal]: netTotal,
            [SalesOverviewReportTableAccessor.PaymentDate]: paidDate,
            [SalesOverviewReportTableAccessor.TaxTotal]: taxTotal,
            id: id.toString(),
            isPaid: isPaidInvoice,
          }
        },
      ),
    [dateSelection, salesOverviewReport],
  )
}
